<div class="adf-empty-content" [title]="title | translate">
    <adf-icon class="adf-empty-content__icon" [value]="icon"></adf-icon>
    <div class="adf-empty-content__title">{{ title | translate }}</div>
    <div class="adf-empty-content__subtitle">{{ subtitle | translate }}</div>
    <ng-content></ng-content>
</div>
